module.exports = __webpack_public_path__ + "static/media/shade_apple_2.f8df7b1f.png";